import { useGetUserQuery } from 'api';
import { useAuthStore } from 'stores/authStore';

export const useCurrentUser = () => {
  const authToken = useAuthStore((state) => state.userToken);

  const { data } = useGetUserQuery({
    enabled: !!authToken,
    staleTime: 1000 * 60 * 5, // otherwise this query, which is used a bit everywhere, would be called too often */
  });

  return data ? data.user : null;
};

export const useTrueUserId = () => useAuthStore((state) => state.trueUserId);

export const useIsAdminImpersonating = () => {
  const trueUserId = useTrueUserId();
  const currentUserId = useAuthStore((state) => state.currentUserId);
  return !!(currentUserId && trueUserId && trueUserId !== currentUserId);
};
